import CompanyInfo from './CompanyInfo'
import Contact from './Contact'

const ContactUsPage = () => {
    return (
        <>
            {/* <TitleBarMin title="Contact Us"></TitleBarMin> */}
            <div >
            <Contact />
            </div>
            {/* <CompanyInfo /> */}
            

        </>
    )
}

export default ContactUsPage